const getNextSoundDate = function(alarm) {
  if (!alarm.days) return;

  let now = new Date();
  const todayWkdayNumber = now.getDay() + 1;
  const isTimePassed = (
    now.getHours() > alarm.hours ||
    (
      now.getHours() === alarm.hours &&
      now.getMinutes() >= alarm.minutes
    )
  );
  now.setHours(alarm.hours);
  now.setMinutes(alarm.minutes);

  let nextSoundWkdayNumber = alarm.days
    .sort()
    .find(day => {
      return isTimePassed ? day > todayWkdayNumber : day >= todayWkdayNumber
    });

  nextSoundWkdayNumber = nextSoundWkdayNumber ? nextSoundWkdayNumber : alarm.days.sort()[0];

  if (nextSoundWkdayNumber === todayWkdayNumber && isTimePassed) {
    now.setDate(now.getDate() + 7);
  } else if (nextSoundWkdayNumber >= todayWkdayNumber) {
    now.setDate(now.getDate() + (nextSoundWkdayNumber - todayWkdayNumber));
  } else {
    now.setDate(now.getDate() + (todayWkdayNumber - 7 + nextSoundWkdayNumber));
  }
  return now;
};

export {
  getNextSoundDate
};



// WEBPACK FOOTER //
// ./src/utils/alarms.js